import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74508eb1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view-container" }
const _hoisted_2 = {
  key: 0,
  class: "load-container"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("地图加载中...")

import { computed } from "vue"
import Map from "@/layout/mapMain/map/index.vue"
import MapTool from "@/layout/mapMain/mapTool/index.vue"
import { useMapStore } from "@/store/modules/map"
import { Loading } from "vant"


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const mapStore = useMapStore()
const globalLoading = computed(() => {
  return mapStore.globalLoading
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Map),
    _createVNode(MapTool),
    (_unref(globalLoading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(Loading), {
            type: "spinner",
            size: "28px",
            color: "#1989fa",
            vertical: ""
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})